import {
  type ParametersGeoBoundingBox,
  ParametersGeoBoundingBoxTypeEnum,
} from "@/lib/api/types";

/** Base layer coords: [south-west, north-east] as { lat, lng }. */
export type BaseLayerCoords = [{ lat: number; lng: number }, { lat: number; lng: number }];

/**
 * Shared map region presets (NESW bounds). Used by map widget and model-map widget.
 */
export class MapRegion {
  constructor(
    public north: number,
    public south: number,
    public east: number,
    public west: number,
  ) {}

  /** Map to base_layer_coords format: [south-west, north-east]. */
  toBaseLayerCoords(): BaseLayerCoords {
    return [
      { lat: this.south, lng: this.west },
      { lat: this.north, lng: this.east },
    ];
  }

  /** Map to API ParametersGeoBoundingBox (includes required type). */
  toGeoBoundingBox(): ParametersGeoBoundingBox {
    return {
      type: ParametersGeoBoundingBoxTypeEnum.BoundingBox,
      north_latitude: this.north,
      south_latitude: this.south,
      east_longitude: this.east,
      west_longitude: this.west,
    };
  }
}

/** Netherlands (mainland). Full precision to match historical map/model-map usage. */
export const mapRegionPresetNl = new MapRegion(53.57885, 50.742863, 6.879572, 3.573652);

/** BES islands (Bonaire, Sint Eustatius, Saba). Dutch Caribbean special municipalities. */
export const mapRegionPresetBes = new MapRegion(21.5, 7.5, -57, -73);
